import { getScrollEventTarget, getScrollTop, scrollContainerMediaQuery } from '@theme/scroll-container';

/**
 * A custom element that shows a floating product bar (image, title, price,
 * link to the product page) once the page has been scrolled past a
 * configurable threshold. Unlike <sticky-add-to-cart>, it has no variant or
 * cart logic - it's a standalone promo bar a merchant can drop on any
 * template (e.g. the home page) pointing at any product.
 */
class StickyProductButton extends HTMLElement {
  #controller = new AbortController();

  /** @type {number} */
  #threshold = 400;

  /** @type {EventTarget | null} */
  #scrollTarget = null;

  connectedCallback() {
    const { signal } = this.#controller;

    this.#threshold = parseInt(this.dataset.scrollThreshold || '', 10) || 400;

    this.#bindScrollTarget();
    // The scroll container switches between `.page-wrapper` (desktop) and
    // `document` (mobile) at the theme's squeeze-layout breakpoint, so the
    // listener needs to move with it.
    scrollContainerMediaQuery.addEventListener('change', this.#bindScrollTarget, { signal });
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  #bindScrollTarget = () => {
    this.#scrollTarget?.removeEventListener('scroll', this.#handleScroll);

    this.#scrollTarget = getScrollEventTarget();
    this.#scrollTarget.addEventListener('scroll', this.#handleScroll, { passive: true });

    this.#handleScroll();
  };

  #handleScroll = () => {
    const bar = this.querySelector('.sticky-product-button__bar');
    if (!(bar instanceof HTMLElement)) return;

    bar.dataset.stuck = String(getScrollTop() > this.#threshold);
  };
}

if (!customElements.get('sticky-product-button')) {
  customElements.define('sticky-product-button', StickyProductButton);
}
